import { useGoogleLogin } from "@react-oauth/google";
import { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useNotify } from "./NotificationProvider";

const AuthContext = createContext<any>(null);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const notify = useNotify();
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [user, setUser] = useState<any>(() => {
    const savedUser = localStorage.getItem("user");
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const navigate = useNavigate();

  const login = (data: any) => {
    localStorage.setItem("token", data?.token);
    localStorage.setItem("user", JSON.stringify(data?.user));
    setToken(data?.token);
    setUser(data?.user);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");

    const root = document.getElementsByTagName('html')[0]
    root.classList.remove('menu-opened')
    
    setToken("");
    setUser(null);
    navigate("/login");
  };

  const loginWithGoogle = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        // const res = await axios.post("/api/auth/google", {
        //   token: tokenResponse.access_token,
        // });
        // const { token, user } = res.data;
        // login({ token, user });
        // navigate("/dashboard");
      } catch (error) {
        console.error("Google login failed", error);
        notify.error({ message: "Google login failed" });
      }
    },
    onError: () => notify.error({ message: "Google login failed" }),
  });

  return (
    <AuthContext.Provider
      value={{
        token,
        login,
        logout,
        loginWithGoogle,
        isAuthenticated: !!token,
        role: user?.role,
        user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AlertProvider");
  }
  return context;
};
